import React, { useEffect, useRef, useState } from "react";
import cs from 'classnames';
import getCenter from "geolib/es/getCenter";
import classes from "views/MapView/mapview.module.scss";
import {useMedia} from "react-use";
import LocationsList from "views/MapView/LocationsList";
import ReactMapboxGl, {Marker, Popup} from "react-mapbox-gl";
import MapMarker from "assets/images/map-marker.png";
import CloseIcon from "assets/images/close.png";

/* eslint-disable react/style-prop-object */
const Map = ReactMapboxGl({
  accessToken:
    "pk.eyJ1IjoibGF2c2hhaCIsImEiOiJja3F1eTRoeDYwOTljMnBvNXBuYWxpanR0In0.VUKqSS8aNGA6EZxovM8hCg",
});

const MapView = ({ locations, city, setCity }) => {
  const isMobile = useMedia('(max-width: 768px)');
  const [showMap, setShowMap] = useState(false);
  const [cityLocations, setCityLocations] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [center, setCenter] = useState([0, 0]);
  const mapRef = useRef(null);

  useEffect(() => {
    const filteredLocations = [
      ...locations.filter((loc) => loc?.acf?.city === city),
    ];
    setCityLocations([...filteredLocations]);
    const centerPoint = getCenter(
      filteredLocations.map((loc) => ({
        latitude: loc?.acf?.google_map_location.lat,
        longitude: loc?.acf?.google_map_location.lng,
      }))
    );
    setCenter([centerPoint.longitude || 0, centerPoint.latitude || 0]);
    setSelectedLocation(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [city]);

  useEffect(() => {
    // Added to make sure page starts from top.
    window.scrollTo(0,0);

    // Toggling overflow class on mobile view to make sure map below list doesn't show up
    if(isMobile) {
      if (showMap && document.documentElement.classList.contains('overflow-hidden')) {
        document.documentElement.classList.remove('overflow-hidden');
      } else if (!showMap && !document.documentElement.classList.contains('overflow-hidden')) {
        document.documentElement.classList.add('overflow-hidden');
      }
    }
  }, [showMap, isMobile])

  const onCityClick = (location, coords) => () => {
    setSelectedLocation(location);
    if(isMobile) {
      setShowMap(true);
    }
    mapRef.current.state.map.flyTo({
      center: coords,
      essential: true,
    });
  };

  const renderPopup = () => {
    const loc = selectedLocation?.acf?.google_map_location || null;
    const coords = loc ? [loc.lng, loc.lat] : [];
    return (
      <Popup coordinates={coords} offset={[0, -20]} style={{ padding: 0 }}>
        <div className={classes.popup}>
          <span
            className={classes.closeBtn}
            onClick={() => setSelectedLocation(null)}
          >
            <img src={CloseIcon} height={24} width={24} alt="Close" />
          </span>
          <h4>{selectedLocation?.title?.rendered}</h4>
          {selectedLocation.cuisine_type ? (
            <span>{selectedLocation.cuisine_type}</span>
          ) : null}
          {selectedLocation.acf?.address_field ? (
            <p>{selectedLocation.acf.address_field}</p>
          ) : null}
          <div
            className={classes.openBtn}
            onClick={() => {
              window.open(
                `https://www.google.com/maps/place/${selectedLocation?.acf?.address_field}/@${loc.lat},${loc.lng},10z`
              );
            }}
          >
            Show location
          </div>
        </div>
      </Popup>
    );
  };

  const renderMap = () => {
    return (<Map
      style="mapbox://styles/mapbox/dark-v10"
      containerStyle={{
        height: "100vh",
        width: !isMobile ? "calc(100vw - 350px)" : "100vw",
        position: isMobile ? "absolute" : "relative"
      }}
      ref={mapRef}
      animationOptions={{
        offset: center,
      }}
      flyToOptions={{
        speed: 8,
      }}
      zoom={[10]}
      center={center}
    >
      {cityLocations.map((location) => {
        const loc = location?.acf?.google_map_location || null;
        const coords = loc ? [loc.lng, loc.lat] : [];
        return (
          <Marker
            id={`marker-${location.id}`}
            key={location.id}
            coordinates={coords}
            onClick={() => setSelectedLocation(location)}
            anchor="bottom"
          >
            <img src={MapMarker} height={18} width={18} alt="Marker" />
          </Marker>
        );
      })}
      {selectedLocation ? renderPopup() : null}
    </Map>)
  }

  return (
    <div className={classes.root}>
      {!isMobile ? (
        <div className={cs(classes.mapWrapper)}>
          <LocationsList
            onCityClick={onCityClick}
            setCity={setCity}
            cityLocations={cityLocations}
            city={city}
          />
          {renderMap()}
        </div>
      ) : (
        <div className={cs(classes.mapWrapper, {[classes.noBg]: showMap})}>
          <div className={cs("flex-column", {"d-none": showMap, "d-flex": !showMap})}>
            <div className={cs(classes.mobileTabsWrapper, {[classes.relative]: !showMap})}>
              <div className={cs(classes.tabBtn, { [classes.active]: !showMap })} onClick={() => setShowMap(false)}>List</div>
              <div className={cs(classes.tabBtn, { [classes.active]: showMap })} onClick={() => setShowMap(true)}>Map</div>
            </div>
            <LocationsList
              onCityClick={onCityClick}
              setCity={setCity}
              cityLocations={cityLocations}
              city={city}
            />
          </div>
          <div>
          <div className={classes.mobileTabsWrapper}>
            <div className={cs(classes.tabBtn, { [classes.active]: !showMap })} onClick={() => setShowMap(false)}>List</div>
            <div className={cs(classes.tabBtn, { [classes.active]: showMap })} onClick={() => setShowMap(true)}>Map</div>
          </div>
            {renderMap()}
          </div>
        </div>
      )}
    </div>
  );
};

export default MapView;
